import { getAuthHeaders } from './authFetch';
/**
 * uploadUrl - Utilitaires pour les fichiers uploadés protégés
 * 
 * Pour les <img> : utiliser le composant ProtectedImage à la place.
 * Pour les cas programmatiques (PDF export) : utiliser fetchProtectedBlob.
 */

// Simple passthrough pour rétrocompatibilité — ne pas utiliser pour les nouvelles images
export function uploadUrl(path) {
  return path;
}

// Charge un fichier protégé via fetch + Authorization, retourne un blob URL
export async function fetchProtectedBlob(uploadPath) {
  const apiPath = uploadPath.replace(/^\/uploads\//, '/api/media/');
  try {
    const response = await fetch(apiPath, {
      headers: getAuthHeaders()
    });
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (e) {
    console.error('fetchProtectedBlob error:', e);
    return null;
  }
}
